/**
 * IBA Servicing brand mark.
 * Uses the geometric "book/burst" mark from the original ISF identity,
 * paired with plain "IBA SERVICING" wordmark so brand text stays editable.
 */

// Minimal recreation of the ISF geometric mark (book + rising rays/burst).
// Rendered as SVG so it scales cleanly and uses the deck's oxblood primary.
function BrandMark({ className = "h-6 w-6" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Rising rays / burst */}
      <g stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" fill="none">
        <line x1="32" y1="4" x2="32" y2="14" />
        <line x1="14" y1="10" x2="20" y2="18" />
        <line x1="50" y1="10" x2="44" y2="18" />
        <line x1="6" y1="24" x2="14" y2="26" />
        <line x1="58" y1="24" x2="50" y2="26" />
      </g>
      {/* Open book base */}
      <g fill="currentColor">
        <path d="M6 34 L32 30 L32 58 L6 54 Z" opacity="0.95" />
        <path d="M58 34 L32 30 L32 58 L58 54 Z" opacity="0.75" />
        <path d="M32 30 L32 58" stroke="white" strokeWidth="1.25" />
      </g>
    </svg>
  );
}

// Full lockup: mark + wordmark
export function LogoMark({ className = "h-6 w-auto", alt = "IBA Servicing" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 text-primary ${className}`}
      aria-label={alt}
      data-testid="brand-logo"
    >
      <BrandMark className="h-full w-auto flex-shrink-0" />
      <span className="font-display text-foreground text-[15px] md:text-[16px] leading-none tracking-tight font-semibold whitespace-nowrap">
        IBA <span className="text-primary">Servicing</span>
      </span>
    </span>
  );
}

// Mark-only (for places that just want the symbol)
export function LogoIcon({ className = "h-8 w-8" }) {
  return (
    <span className={`inline-flex text-primary ${className}`} aria-hidden="true">
      <BrandMark className="h-full w-full" />
    </span>
  );
}
